/* <dispatch-countdown> — live "order within Xh Ym for dispatch today" line.
   Computes against the visitor's local clock; the Liquid-rendered fallback text
   stays in place until the first update (and wherever JS is unavailable). */
if (!customElements.get('dispatch-countdown')) {
  class DispatchCountdown extends HTMLElement {
    connectedCallback() {
      this.line = this.querySelector('[data-dispatch-line]');
      if (!this.line) return;
      this.update();
      this.timer = setInterval(() => this.update(), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    update() {
      const cutoff = Number(this.dataset.cutoffHour || 14);
      const now = new Date();
      const day = now.getDay();
      let text;
      if (day === 0 || day === 6) {
        text = 'dispatched Monday';
      } else {
        const target = new Date(now);
        target.setHours(cutoff, 0, 0, 0);
        const remaining = target - now;
        if (remaining <= 0) {
          text = day === 5 ? 'dispatched Monday' : 'dispatched tomorrow';
        } else {
          const hours = Math.floor(remaining / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          text = 'order within ' + (hours ? hours + 'h ' : '') + minutes + 'm for dispatch today';
        }
      }
      this.line.textContent = text;
    }
  }

  customElements.define('dispatch-countdown', DispatchCountdown);
}
